<template>
  <span></span>
</template>

<script lang="ts" setup>
import { useRoute, useRouter } from 'vue-router';
import { onMounted } from 'vue';
import { useUser } from '@/modules/auth/store/user.store.ts';
import { sleep } from '@/core/lib';
import bus from '@/plugins/bus';
import { http } from '@/plugins/axios';

const router = useRouter();

const getStudyDetails = async (studyId: string) => {
  try {
    const response = await http.get<{
      content: { id: string; recruitmentjobId: string };
    }>('/study-details', {
      params: {
        studyId,
      },
    });
    return {
      jobId: response.data.content.recruitmentjobId,
      segmentId: response.data.content.id,
    };
  } catch (e: any) {}
  return null;
};

onMounted(async () => {
  let route;
  let count = 0;
  while (!route) {
    route = useRoute();
    await sleep(100);
    count += 20;
    if (count > 1000) {
      break;
    }
  }

  try {
    const user = useUser();
    const ok = await user.isAuthenticated();

    if (ok) {
      const url = new URL(location.href);
      if (url.searchParams.has('studyId')) {
        const studyId = url.searchParams.get('studyId') ?? '';
        if (studyId && studyId != '') {
          const response = await getStudyDetails(studyId);
          if (response) {
            router.replace({
              name: 'recruitment.job.interviews',
              params: response,
              hash: window.location.hash,
            });
            return;
          }
        }
      }
      // already signed in
      router.replace({
        name: 'home',
      });
      return;
    }

    bus.emit('redirectLogin');
  } catch (e) {}
});
</script>
